<template>
  <div>
    <page-header>
      <template #breadcrumbs>
        <router-link :to="{ name: 'Journal', query: { page1: this.$route.query.page1 } }">Дневник ЛРАС</router-link> &raquo;
        <template v-if="item && item.patient">{{ item.patient.surname }} {{ item.patient.name }} {{ item.patient.patronimic }}</template>
      </template>
      <h2>Карточка дневника ЛРАС</h2>
    </page-header>
      <ul class="nav nav-tabs nav-justified p-3 d-flex align-items-center">
          <li class="nav-item" v-if="loaded && item.id && (accessMatrix.view.patient || accessMatrix.edit.patient)">
              <a class="nav-link" @click.prevent="goToPatient()" href="#patient">Карточка пациента</a>
          </li>
          <li class="nav-item" v-if="loaded && item.id && (accessMatrix.view.diagnos || accessMatrix.edit.diagnos)">
              <a 
                class="nav-link" 
                @click.prevent="setActive('tab6')" 
                :class="{ active: isActive('tab6') }" 
                href="#tab6">
                Диагностика
              </a>
          </li>
          <li class="nav-item" v-if="false && loaded && item.id && (accessMatrix.view.route || accessMatrix.edit.route)">
              <a class="nav-link text-small" @click.prevent="setActive('tab1')" :class="{ active: isActive('tab1') }" href="#tab1">Карточка маршрутного листа</a>
          </li>
          <li class="nav-item" v-if="loaded && (accessMatrix.view.imar || accessMatrix.edit.imar)">
              <a 
                class="nav-link" 
                @click.prevent="setActive('tab7')" 
                :class="
                  {active: isActive('tab7'),'marker-new': isModfiedClass('imar')}
                " 
                href="#tab7">
                ИМАР
              </a>
          </li>
          <li class="nav-item"  v-if="loaded && (accessMatrix.view.ippsu || accessMatrix.edit.ippsu)">
              <a class="nav-link" @click.prevent="setActive('tab2')" :class="{ active: isActive('tab2') }" href="#tab2">ИППСУ</a>
          </li>
          <li class="nav-item" v-if="loaded && (accessMatrix.view.pmpk || accessMatrix.edit.pmpk)">
              <a 
                class="nav-link" 
                @click.prevent="setActive('tab3')" 
                :class="{
                  active: isActive('tab3'),'marker-new': isModfiedClass('pmpk')
                }" 
                href="#tab3">
                ПМПК
                <i class="fas fa-info-circle text-danger ml-2" v-if="tab3Invalid"></i>
              </a>
          </li>
          <li class="nav-item" v-if="loaded && (accessMatrix.view.ipra || accessMatrix.edit.ipra)">
              <a class="nav-link" @click.prevent="setActive('tab4')" :class="{ active: isActive('tab4') }" href="#tab4">ИПРА</a>
          </li>
          <!-- <li class="nav-item" v-if="loaded && (accessMatrix.view.medServ || accessMatrix.edit.medServ)">
              <a class="nav-link" @click.prevent="setActive('tab5')" :class="{ active: isActive('tab5') }" href="#tab5">Мед. услуги</a>
          </li>           -->
      </ul>
    <div class="card">
      <div>
        <div class="tab-content" id="myTabContent" >
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab1') }" id="tab1"
               v-if="item.id && (accessMatrix.view.route || accessMatrix.edit.route)">
            <template v-if="item.isShowTabRoute">
              <JournalTabRoute :journal-id="item.id"  
                v-on:saveJournalRoute="onSaveJournalRoute($event)" 
                :isReadonly="isReadonly || !accessMatrix.edit.route"
                v-on:reload="onReload()">
              </JournalTabRoute>
            </template>
            <template v-else>
              <div>
                Необходимо заполнить и утвердить карту диагностики
                <div class="card-footer mt-5">
                    <div class="d-flex align-items-center float-right">
                      <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">Закрыть</button-component>
                    </div>
                </div>
              </div>
            </template>
          </div>

          <div class="tab-pane fade" :class="{ 'active show': isActive('tab2') }" id="tab2"
               v-if="accessMatrix.view.ippsu || accessMatrix.edit.ippsu">
            <Ippsu v-if="item.id" :journal-id="item.id" :patient-id="item.patientId"
                   :is-readonly="isReadonly || !accessMatrix.edit.ippsu" />
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab3') }" id="tab3"
               v-if="accessMatrix.view.pmpk || accessMatrix.edit.pmpk">
            <journal-pmpk
                    v-if="item.id"
                    :journal-id="item.id"
                    :is-readonly="isReadonly || !accessMatrix.edit.pmpk"
                    v-bind:needSave="needSave"
                    v-on:journalPmpkInvalid="onTabInvalid('tab3')"
                    :parsedStatusOfChange="this.parsedStatusOfChange"
            />
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab4') }" id="tab4"
               v-if="accessMatrix.view.ipra || accessMatrix.edit.ipra">
              <ipra
                  v-if="item.id"
                  :journal-id="item.id"
                  :is-readonly="isReadonly || !accessMatrix.edit.ipra"
              />
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab5') }" id="tab5"
               v-if="accessMatrix.view.medServ || accessMatrix.edit.medServ">
            Мед. услуги
            <div class="card-footer mt-5">
                <div class="d-flex align-items-center float-right">
                  <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">Закрыть</button-component>
                </div>
            </div>  
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab6') }" id="tab6"
               v-if="item.id && (accessMatrix.view.diagnos || accessMatrix.edit.diagnos)">
            <journal-tab-diagnostic :journal-id="item.id" @approve="approveDiagnostic"
                                    :is-readonly="isReadonly || !accessMatrix.edit.diagnos"
            />
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab7') }" id="tab7">
              <journal-tab-imar 
                :journal-id="item.id"
                :is-active="true"
                :current-signer-id="item.currentSignerId"
                :is-readonly="isReadonly || !accessMatrix.edit.imar"
                v-on:reload="onReload()"
                :isShowTabImar="item.isShowTabImar"
                :responseStatusOfChange="this.responseStatusOfChange"
                :parsedStatusOfChange="this.parsedStatusOfChange"
              />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '../api/journal'
import apiPatientChange from '@/common/api/patientChange';
import Constants from '../../../common/constants'
import PageHeader from "@/common/components/page/PageHeader";
import JournalTabDiagnostic from '../components/JournalTabDiagnostic.vue';
import JournalTabRoute from '../components/JournalTabRoute.vue';
import JournalTabImar from '../components/JournalTabImar.vue';
import Ippsu from '../components/Ippsu.vue';
import security from "../../../common/mixins/security";
import JournalPmpk from "../components/JournalPmpk";
import Ipra from "../components/Ipra";
import ButtonComponent from "@/common/ui/ButtonComponent";

export default {
  name: "JournalCard",
  components: {
    Ipra,
    JournalPmpk,
    PageHeader,
    JournalTabDiagnostic,
    JournalTabImar,
    JournalTabRoute,
    Ippsu,
    ButtonComponent
  },
  props: {
    patient:{
      type: Number,
      required: false,
      default: null
    },
  },

  mixins: [security],
  created() {
    this.initializeAccessMatrix();
    this.loadPage();
  },
  data() {
    return {
      id: this.$route.params.id,
      statusOfChangeId: this.$route.params?.statusOfChangeId,
      responseStatusOfChange: null,
      parsedStatusOfChange: {
        imarStatus: {
          active: null,
          itemId: null,
        },
        serviceEnd: {
          active: null,
          itemId: null,
        },
        imarEnd: {
          active: null,
          itemId: null,
        },
        serviceNotBecome: {
          active: null,
          itemId: null,
        },
        dataAddress: {
          active: null,
          itemId: null,
        },
        dataSchool: {
          active: null,
          itemId: null,
        },
        dataSchoolProf: {
          active: null,
          itemId: null,
        },
        dataWork: {
          active: null,
          itemId: null,
        },
        organization: {
          active: null,
          itemId: null,
        },
      },
      isReadonly: this.$route.params.action === 'view',
      item: {
        
      },
      activeItem: this.$route.params.tab || this.$route.query.tab || 'tab7',
      needSave: 0,
      tab3Invalid: false,
      tabPmpkSaved: null,
      tabRouteSaved: null,
      accessMatrix: {
        view: {
          route: true,
          imar: true,
          ippsu: true,
          pmpk: true,
          ipra: true,
          medServ: true,
          diagnos: true,
          patient: true
        },
        edit: {
          route: true,
          imar: true,
          ippsu: true,
          pmpk: true,
          ipra: true,
          medServ: true,
          diagnos: true,
          patient: true
        },
      },
      loaded: false      
    };
  },
  methods: {
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    },
    goToPatient() {
      let action = this.accessMatrix.edit.patient && this.$route.params.action == "edit"
        ? "edit" : "view";
      this.$router.push({
        name: "patientCard",
        params: { action: action, id: this.id },
        query: { page: this.$route.query.page, page2: this.$route.query.page2 }
      });
    },
    loadStatusIds(){
      apiPatientChange.patientChangeGet(this.id).then(response => {
        this.responseStatusOfChange = response.data;
        if(this.responseStatusOfChange.length > 0){
          for (let i = 0; i < this.responseStatusOfChange.length; i++) {
            let interationStatusOfChange = this.responseStatusOfChange[i].patientChangeId,
              interationStatusItemId = this.responseStatusOfChange[i].itemId;
            switch (interationStatusOfChange) {
              case 1:
                this.parsedStatusOfChange.imarStatus = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 2:
                this.parsedStatusOfChange.serviceEnd = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 3:
                this.parsedStatusOfChange.imarEnd = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 4:
                this.parsedStatusOfChange.serviceNotBecome = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 5:
                this.parsedStatusOfChange.dataAddress = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 6:
                this.parsedStatusOfChange.dataSchool = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 7:
                this.parsedStatusOfChange.dataSchoolProf = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 8:
                this.parsedStatusOfChange.dataWork = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 9:
                this.parsedStatusOfChange.organization = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              default:
                break;
            }
          }
          if(
            this.parsedStatusOfChange.dataSchool.active == true || 
            this.parsedStatusOfChange.dataSchoolProf.active == true
          ){
            this.setActive('tab3');
          }
          else if(
            this.parsedStatusOfChange.imarStatus.active == true || 
            this.parsedStatusOfChange.serviceEnd.active == true ||
            this.parsedStatusOfChange.imarEnd.active == true ||
            this.parsedStatusOfChange.serviceNotBecome.active == true ||
            this.parsedStatusOfChange.organization.active == true
          ){
            this.setActive('tab7');
          }
        }
      });
    },
    loadPage() {
        if (this.patient || this.id > 0) {
          API.find(this.patient || this.id).then(response => {
            this.item = response.data;
            this.loaded = true;

            if (this.item.patient.isDeleted) {
              this.isReadonly = true;
            }
          });
        }
        else
          this.loaded = true;

        this.loadStatusIds();
    },
    onReload() {
      this.$router.go();
    },  
    onTabInvalid(name) {
      if (name == 'tab3')
        this.tab3Invalid = true;
    },
    close() {
      this.$router.push({name: 'Journal', query: { page1: this.$route.query.page1 }});
    },
    approveDiagnostic() {
      if(this.item.diagnosticStatus != 2) {
        this.loadPage();
      }
    },
    initializeAccessMatrix() {
      this.checkPermission(Constants.JournalRouteView).then((response) => {
        this.accessMatrix.view.route = response.data
      });
      this.checkPermission(Constants.JournalImarView).then((response) => {
        this.accessMatrix.view.imar = response.data
      });
      this.checkPermission(Constants.IPPSUView).then((response) => {
        this.accessMatrix.view.ippsu = response.data
      });
      this.checkPermission(Constants.PMPKView).then((response) => {
        this.accessMatrix.view.pmpk = response.data
      });
      this.checkPermission(Constants.IPRAView).then((response) => {
        this.accessMatrix.view.ipra = response.data
      });
      this.checkPermission(Constants.MedServiceView).then((response) => {
        this.accessMatrix.view.medServ = response.data
      });
      this.checkPermission(Constants.JournalDiagnosticView).then((response) => {
        this.accessMatrix.view.diagnos = response.data
      });
      this.checkPermission(Constants.PatientView).then((response) => {
        this.accessMatrix.view.patient = response.data
      });

      this.checkPermission(Constants.JournalRouteEdit).then((response) => {
        this.accessMatrix.edit.route = response.data
      });
      this.checkPermission(Constants.JournalImarEdit).then((response) => {
        this.accessMatrix.edit.imar = response.data
      });
      this.checkPermission(Constants.IPPSUEdit).then((response) => {
        this.accessMatrix.edit.ippsu = response.data
      });
      this.checkPermission(Constants.PMPKEdit).then((response) => {
        this.accessMatrix.edit.pmpk = response.data
      });
      this.checkPermission(Constants.IPRAEdit).then((response) => {
        this.accessMatrix.edit.ipra = response.data
      });
      this.checkPermission(Constants.MedServiceEdit).then((response) => {
        this.accessMatrix.edit.medServ = response.data
      });
      this.checkPermission(Constants.JournalDiagnosticEdit).then((response) => {
        this.accessMatrix.edit.diagnos = response.data
      });
      this.checkPermission(Constants.PatientEdit).then((response) => {
        this.accessMatrix.edit.patient = response.data
      });
    },
    isModfiedClass(item) {
      if(item == 'pmpk')
        if(
          this.parsedStatusOfChange.dataSchool.active == true || 
          this.parsedStatusOfChange.dataSchoolProf.active == true
        ){
          return true;
        }
        else return false;
      if(item == 'imar')
        if(
          this.parsedStatusOfChange.imarStatus.active == true || 
          this.parsedStatusOfChange.serviceEnd.active == true ||
          this.parsedStatusOfChange.imarEnd.active == true ||
          this.parsedStatusOfChange.serviceNotBecome.active == true ||
          this.parsedStatusOfChange.organization.active == true
        ){
          return true;
        }
        else return false;
    },
  },

};
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

h2 {
  margin-top: 21px;
}
.tab-content{
    background-color: transparent;
}
.nav-tabs {
    margin: 16px 36px 0 36px;
    justify-content: center;
    border: none;

    .nav-item {
        margin-top: 12px;
        max-width: 240px;
        width: 100%;
        margin-right: 8px;
        margin-left: 8px;

        .nav-link {
            padding: 14.5px 20px;
            text-align: center;
            font-family: "Source Sans Pro", sans-serif;
            font-style: normal;
            font-weight: 600;
            min-width: 174px;
            font-size: 16px;
            line-height: 120%;
            color: $gray-dark;
            border: 1px solid $gray-light1;
            box-sizing: border-box;
            border-radius: 6px;

            &.active {
                color: $blue-light;
                border: 1px solid $blue-light;
            }
            &.text-small {
              font-size: 12px;
              line-height: 160%;
            }
        }
    }
}
.card {
    padding: 24px;
    margin: 10px 24px 0 24px;
    border-radius: 24px;
    border: none;
    box-shadow: none;
    background-color: #fff;
}
.form-group.required .control-label:after { 
   content:"*";
   color:red;
}
.form-check.required .control-label:after { 
   content:"*";
   color:red;
}
.card-footer{
    padding: 0;
    background-color: transparent;
    border: none;
}
</style>